import { createContext } from 'react'

import {
  AIAssistantAppConfigProps,
  NavigationContextTypes
} from './navigationContext.types'

export const AIAssistantConfigInitial: AIAssistantAppConfigProps = {
  aiAssistantState: 'closed',
  appSlug: 'innos'
}

export const NavigationContext = createContext<NavigationContextTypes>({
  setSidebarContent: () => {},
  sidebarContent: null,
  livechatState: 'closed',
  setLivechatState: () => {},
  gdprState: 'closed',
  setGdprState: () => {},
  notificationPaneState: 'closed',
  setNotificationPaneState: () => {},
  notificationState: 'closed',
  setNotificationState: () => {},
  AIAssistantConfig: { ...AIAssistantConfigInitial },
  setAIAssistantConfig: () => {},
  emailAppUnreadMessagesCount: 0,
  setEmailAppUnreadMessagesCount: () => {},
  feedbackState: 'opened',
  setFeedbackState: () => {},
  copilotState: 'opened',
  setCopilotState: () => {}
})
